import React from 'react'
import {Map, GoogleApiWrapper, Marker} from 'google-maps-react'

const mapStyles = {
  height: '500px',
  position: 'relative',
  borderRadius: '1px',
}

export const MapContainer = props => {
  return props.latlng ? (
    <>
      <Map
        google={props.google}
        zoom={13}
        style={mapStyles}
        initialCenter={{
          lat: parseFloat(props.latlng ? props.latlng.lat : null),
          lng: parseFloat(props.latlng ? props.latlng.lng : null),
        }}
      >
        <Marker
          position={{
            lat: parseFloat(props.latlng ? props.latlng.lat : null),
            lng: parseFloat(props.latlng ? props.latlng.lng : null),
          }}
        />
      </Map>
      <div
        className="map_close"
        onClick={() => {
          props.handleClose()
        }}
      ></div>
    </>
  ) : null
}

export default GoogleApiWrapper({
  apiKey: '',
})(MapContainer)
